import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() text: string;
  @Input() classList: string;
  @Input() disabled: boolean;
  @Input() fs: string | number;
  @Input() fw: string | number;
  @Input() mt: string | number;
  @Input() ml: string | number;
  @Input() mr: string | number;
  @Input() pixelWidth: string | number;
  @Input() perWidth: string | number;
  @Input() background: string;
  @Input() color: string;
  @Input() slot: 'end' | 'start';
  @Input() icon: string; //name svg inside assets/icons folder;
  @Input() type:
    'default' |
    'primary' |
    'transparent' |
    'transparent-white' |
    'clear' |
    'clear-primary' |
    'outline' |
    'outline-primary' |
    'link-primary' |
    'dark';

  @Input() size: 'large' | 'default';


  constructor() {
    this.slot = 'start';
    this.text = '';
    this.color = '';
    this.type = 'default';
    this.classList = '';
    this.ml = '';
    this.mr = '';
    this.mt = '';
    this.pixelWidth = '';
    this.background = '';
    this.perWidth = '';
    this.size = 'default';
  }

  ngOnInit(): void {
  }

}
